module.exports = __webpack_public_path__ + "static/media/comment_info_icon.ff08c173.svg";